// client/plugins/addLinkOnPastePlugin.ts
import { Plugin } from "prosemirror-state";
function addLinkOnPastePlugin(schema) {
  return new Plugin({
    props: {
      handlePaste(view, event, slice) {
        const { state, dispatch } = view;
        const { schema: schema2 } = state;
        const { selection } = state;
        const pastedText = (event.clipboardData || window.clipboardData).getData("text");
        const urlRegex = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i;
        if (!urlRegex.test(pastedText)) {
          return false;
        }
        if (selection.empty) {
          return false;
        }
        const linkMark = schema2.marks.link;
        if (!linkMark) {
          console.warn("Schema enth\xE4lt keine Link-Markierung!");
          return false;
        }
        const tr = state.tr.addMark(
          selection.from,
          selection.to,
          linkMark.create({ href: pastedText, target: "_self" })
        );
        dispatch(tr);
        return true;
      }
    }
  });
}
export {
  addLinkOnPastePlugin
};
